import { Box, Button, HStack, Text } from "@chakra-ui/react"

interface DateRangeSelectorProps {
  activePreset: Preset
  onPresetChange: (preset: Preset) => void
}

export type Preset = "7d" | "30d" | "90d" | "all"

export default function DateRangeSelector({
  activePreset,
  onPresetChange,
}: DateRangeSelectorProps) {
  const handlePresetClick = (preset: Preset) => {
    onPresetChange(preset)
  }

  return (
    <Box borderWidth={1} borderRadius="lg" p={4} bg="white">
      <HStack justify="space-between" flexWrap="wrap" gap={4}>
        <Text fontWeight="semibold" fontSize="sm" color="gray.600">
          Date Range:
        </Text>
        <HStack gap={2}>
          <Button
            size="sm"
            variant={activePreset === "7d" ? "solid" : "outline"}
            colorPalette="blue"
            bg={activePreset === "7d" ? "blue.500" : "transparent"}
            color={activePreset === "7d" ? "white" : "blue.500"}
            borderColor="blue.500"
            aria-pressed={activePreset === "7d"}
            _hover={{
              bg: activePreset === "7d" ? "blue.600" : "blue.50",
            }}
            onClick={() => handlePresetClick("7d")}
          >
            Last 7 days
          </Button>
          <Button
            size="sm"
            variant={activePreset === "30d" ? "solid" : "outline"}
            colorPalette="blue"
            bg={activePreset === "30d" ? "blue.500" : "transparent"}
            color={activePreset === "30d" ? "white" : "blue.500"}
            borderColor="blue.500"
            aria-pressed={activePreset === "30d"}
            _hover={{
              bg: activePreset === "30d" ? "blue.600" : "blue.50",
            }}
            onClick={() => handlePresetClick("30d")}
          >
            Last 30 days
          </Button>
          <Button
            size="sm"
            variant={activePreset === "90d" ? "solid" : "outline"}
            colorPalette="blue"
            bg={activePreset === "90d" ? "blue.500" : "transparent"}
            color={activePreset === "90d" ? "white" : "blue.500"}
            borderColor="blue.500"
            aria-pressed={activePreset === "90d"}
            _hover={{
              bg: activePreset === "90d" ? "blue.600" : "blue.50",
            }}
            onClick={() => handlePresetClick("90d")}
          >
            Last 90 days
          </Button>
          <Button
            size="sm"
            variant={activePreset === "all" ? "solid" : "outline"}
            colorPalette="blue"
            bg={activePreset === "all" ? "blue.500" : "transparent"}
            color={activePreset === "all" ? "white" : "blue.500"}
            borderColor="blue.500"
            aria-pressed={activePreset === "all"}
            _hover={{
              bg: activePreset === "all" ? "blue.600" : "blue.50",
            }}
            onClick={() => handlePresetClick("all")}
          >
            All time
          </Button>
        </HStack>
      </HStack>
    </Box>
  )
}
